module.exports = __webpack_public_path__ + "img/sidebar_sl_griechenland_202627.4cce068f.png";